<template>
  <div>
    <div v-if="projectDetail.project_info.exami_type === '公务员录聘'">
      <div class="bkxx-wrap">
        <div class="bkxx-card">
          <div class="card-header">
            <span class="card-title">请选择报考职位</span>
            <span class="card-tip">温馨提示：输入职位（岗位）代码后，系统自动查询对应职位信息</span>
          </div>
          <div class="card-body">
            <el-form label-width="120px" size="small">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="请选择考试地区">
                    <el-cascader v-model="selectOne" :options="area_one_list" :props="props" style="width:100%"></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="请选择报名地市">
                    <el-cascader v-model="selectTwo" :options="area_two_list" :props="props" style="width:100%"></el-cascader>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="职位（岗位）代码">
                    <el-input v-model="pisitionId" placeholder="请输入职位代码" @keyup.enter.native="registerPosition">
                      <el-button slot="append" type="primary" @click="registerPosition">查询</el-button>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20" v-if="positionModel">
                <el-col :span="12">
                  <el-form-item label="单位名称">
                    <el-input :value="positionModel.company" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="职位名称">
                    <el-input :value="positionModel.title" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div class="bkxx-card" v-if="positionModel">
          <div class="card-header"><span class="card-title">职位条件</span><span class="card-tip">（详细内容阅读招考公告）</span></div>
          <div class="card-body">
            <el-descriptions :column="3" border size="small">
              <el-descriptions-item label="岗位咨询电话">{{ positionModel.section_tel }}</el-descriptions-item>
              <el-descriptions-item label="招考人数">{{ positionModel.num }}人</el-descriptions-item>
              <el-descriptions-item label="招考比例">{{ positionModel.percent }}</el-descriptions-item>
            </el-descriptions>
            <div v-if="conditionGroups.length" class="condition-groups">
              <div v-for="(group, index) in conditionGroups" :key="index" class="condition-group">
                <div class="condition-group-title">
                  <span>{{ group.name || ("条件组" + (index + 1)) }}</span>
                  <el-tag size="mini" :type="group.matched ? 'success' : 'danger'">{{ group.matched ? "本组符合" : "本组不符合" }}</el-tag>
                </div>
                <div class="condition-list">
                  <div
                    v-for="(row, rowIndex) in group.conditions"
                    :key="rowIndex"
                    class="condition-list-item"
                    :class="{ 'is-pass': row.matched, 'is-fail': !row.matched }"
                  >
                    <span class="condition-list-index">{{ rowIndex + 1 }}</span>
                    <span class="condition-list-text">{{ conditionPlainText(row) }}</span>
                    <span class="condition-list-result">
                      <i v-if="row.matched" class="el-icon-check condition-pass"></i>
                      <i v-else class="el-icon-close condition-fail"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="condition-group-tip">满足任一条件组即可报考</div>
            </div>
            <div style="margin-top:12px;font-size:14px;color:#606266;" v-if="positionModel.other">
              <span>其他条件：</span><span style="color:#303133;">{{ positionModel.other }}</span>
            </div>
          </div>
        </div>
        <div class="bkxx-card" v-if="positionModel">
          <div class="card-header"><span class="card-title">考试科目</span></div>
          <div class="card-body">
            <el-table :data="tableDetail" style="width:100%" size="small" border>
              <el-table-column width="60" align="center" label="选择">
                <template #default="scope">
                  <el-checkbox :disabled="scope.row.disabled" v-model="tableDetail[scope.$index].check"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="title" label="科目"></el-table-column>
              <el-table-column prop="money" label="费用" width="120"></el-table-column>
            </el-table>
          </div>
        </div>
        <div v-if="!positionModel" class="bkxx-card"><div class="card-body empty-tip">请先输入职位代码并查询</div></div>
        <div class="bkxx-submit" v-if="canSubmitPosition"><el-button type="primary" size="medium" @click="checkBkxx()">确认提交</el-button></div>
      </div>
    </div>
    <div v-if="projectDetail.project_info.exami_type === '研究生招生考试'">
      <div class="bkxx-wrap"><div class="bkxx-card"><div class="card-body" style="width:80%;margin:0 auto;">
        <form-create v-model="fApi" :rule="fRule" :option="option"></form-create>
      </div></div></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";
import { registeredPosition, reqProjectSavedata, reqProjectDetail } from "@/api";
export default {
  data() {
    return {
      props: { multiple: false },
      selectOne: "", selectTwo: "", pisitionId: "",
      positionModel: null, tableDetail: [],
      major_id: "", grade_id: "",
      fApi: {},
      option: {
        resetBtn: false,
        submitBtn: { innerText: "确认提交", show: true },
        global: { upload: { handleIcon: "ios-eye-outline", allowRemove: true } },
        onSubmit: (formData) => {
          if (this.process.enable == 0) { this.$message.error("当前状态无法提交更改"); return false; }
          let formobj = this.fApi.formData();
          formobj.project_id = this.$parent.projectDetail.project_info.id;
          reqProjectSavedata(formobj).then((res) => {
            if (res.data.code === 1) {
              reqProjectDetail({ project_id: this.$parent.projectDetail.project_info.id, step_name: "bkxx" }).then((r) => {
                if (r.data.code === 1) { this.changeProject(r.data.data); this.$parent.next(); }
                else { this.$parent.next(); this.$message.success("资料已保存"); }
              });
            } else { this.$message.error(res.data.msg); }
          });
        },
      },
    };
  },
  props: {
    process_index: 0,
    process: { type: Object, default() { return []; } },
  },
  computed: {
    ...mapState(useMainStore, { projectDetail: "getProjectDetail" }),
    fRule() {
      return this.process && this.process.content && this.process.content.field_list ? this.process.content.field_list : [];
    },
    area_one_list() {
      if (this.projectDetail && this.projectDetail.project_info && this.projectDetail.project_info.exami_type == "公务员录聘") {
        if (this.process && this.process.content && this.process.content.area_list && this.process.content.area_list.area_list) {
          return this.process.content.area_list.area_list.map((i) => ({ value: i.id, label: i.city }));
        }
      }
      return [];
    },
    area_two_list() {
      if (this.projectDetail && this.projectDetail.project_info && this.projectDetail.project_info.exami_type == "公务员录聘" && this.process && this.process.content && this.process.content.area_list) {
        let arr = [];
        let curAreaId = Array.isArray(this.selectOne) ? this.selectOne[0] : this.selectOne;
        this.process.content.area_list.area_list.forEach((item) => {
          if (curAreaId == item.id) {
            let pt = item.point || item.Point;
            if (pt) {
              if (Array.isArray(pt)) {
                arr = pt.map((p) => ({ value: p.id, label: p.city }));
              } else {
                arr = [{ value: pt.id, label: pt.city }];
              }
            }
          }
        });
        return arr;
      }
      return [];
    },
    conditionGroups() {
      if (!this.positionModel) return [];
      var backendGroups = this.positionModel.condition_groups;
      if (Array.isArray(backendGroups) && backendGroups.length) {
        return backendGroups.map((group, index) => ({
          name: group.name || ("条件组" + (index + 1)),
          matched: !!group.matched,
          conditions: Array.isArray(group.conditions) ? group.conditions : [],
        }));
      }
      var raw = this.positionModel.condition_json || this.positionModel.fieldlist_json;
      if (!raw) return [];
      try {
        var definition = typeof raw === "string" ? JSON.parse(raw) : raw;
        var groups = [];
        if (Array.isArray(definition)) {
          groups = definition.length ? [{ name: "默认条件组", conditions: definition }] : [];
        } else if (definition && Array.isArray(definition.groups)) {
          groups = definition.groups;
        }
        return groups.map((group, index) => {
          var rows = (group.conditions || []).map((item) => ({
            ...item,
            matched: this.matchCondition(item),
          }));
          return {
            name: group.name || ("条件组" + (index + 1)),
            matched: rows.every((item) => item.matched),
            conditions: rows,
          };
        });
      } catch (e) { return []; }
    },
    conditionList() {
      return this.conditionGroups.reduce((rows, group) => rows.concat(group.conditions || []), []);
    },
    conditionRows() {
      return this.conditionList;
    },
    conditionsMet() {
      if (!this.positionModel) return false;
      if (typeof this.positionModel.conditions_met === "boolean") return this.positionModel.conditions_met;
      if (!this.conditionGroups.length) return true;
      return this.conditionGroups.some((group) => group.matched);
    },
    canSubmitPosition() {
      return !!this.positionModel && this.conditionsMet;
    },
    applyFieldData() {
      var apply = this.projectDetail && this.projectDetail.apply ? this.projectDetail.apply : {};
      var data = apply.field_data_json || {};
      if (typeof data === "string") {
        try { data = JSON.parse(data); } catch (e) { data = {}; }
      }
      return data || {};
    },
  },
  methods: {
    operatorText(op) {
      return { '=': '等于', '!=': '不等于', '>': '大于', '<': '小于', '>=': '大于等于', '<=': '小于等于' }[op] || op;
    },
    conditionRemark(row) {
      return row.remark || row.label || row.description || "";
    },
    conditionPlainText(row) {
      var title = row.field_title || row.field_label || row.field_name || row.field || "条件";
      var field = row.field || row.field_name || title;
      var op = row.operator || "=";
      var value = this.conditionValueText(row);
      var cleanTitle = String(title).replace(/^请选择/, "").replace(/（.*?）|\(.*?\)/g, "");
      if (this.isAgeField(field, cleanTitle)) {
        if (op === "<" || op === "<=") return value + "岁以下";
        if (op === ">" || op === ">=") return value + "岁及以上";
        if (op === "=" || op === "==") return value + "岁";
      }
      if (this.isBirthdayField(field, cleanTitle)) {
        var birthdayPrefix = this.formatDatePoint(value);
        if (op === "<" || op === "<=") return birthdayPrefix + "前出生";
        if (op === ">" || op === ">=") return birthdayPrefix + "后出生";
        return birthdayPrefix + "出生";
      }
      if (this.isPartyDateField(field, cleanTitle)) {
        var partyPrefix = this.formatDatePoint(value);
        if (op === "<" || op === "<=") return partyPrefix + "前入党";
        if (op === ">" || op === ">=") return partyPrefix + "后入党";
        return partyPrefix + "入党";
      }
      if (cleanTitle.indexOf("民族") !== -1) {
        var nation = this.normalizeNation(value);
        if (op === "!=") return nation === "汉族" ? "少数民族" : "非" + nation;
        return nation;
      }
      if (cleanTitle.indexOf("学历") !== -1 || cleanTitle.indexOf("学位") !== -1) {
        var diplomaTitle = cleanTitle.indexOf("学历") !== -1 ? "学历" : "学位";
        if (op === ">" || op === ">=") return value + "及以上" + diplomaTitle;
        if (op === "<" || op === "<=") return value + "及以下" + diplomaTitle;
        if (op === "!=") return "非" + value + diplomaTitle;
        return value + diplomaTitle;
      }
      if (op === "=" || op === "==") return cleanTitle + "为" + value;
      return cleanTitle + this.operatorSymbol(op) + value;
    },
    conditionValueText(row) {
      return row.value_text || row.required_text || row.value || row.required_value || "";
    },
    isAgeField(field, title) {
      var text = String(field || "") + String(title || "");
      return ["age", "nl", "__age", "年龄"].some((key) => text.indexOf(key) !== -1);
    },
    isBirthdayField(field, title) {
      var text = String(field || "") + String(title || "");
      return ["birthday", "birthdate", "birth_date", "csrq", "出生日期", "出生时间"].some((key) => text.indexOf(key) !== -1);
    },
    isPartyDateField(field, title) {
      var text = String(field || "") + String(title || "");
      return ["party_time", "join_party", "rdsj", "入党时间"].some((key) => text.indexOf(key) !== -1);
    },
    formatDatePoint(value) {
      var text = String(value || "").replace(/\s+00:00:00$/, "");
      var match = text.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
      if (match) return match[1] + "年" + Number(match[2]) + "月" + Number(match[3]) + "日";
      return text;
    },
    normalizeNation(value) {
      var text = String(value || "").trim();
      if (!text) return "";
      if (text === "汉") return "汉族";
      if (/^[\u4e00-\u9fa5]+$/.test(text) && text.slice(-1) !== "族") return text + "族";
      return text;
    },
    operatorSymbol(op) {
      return { '=': '为', '==': '为', '!=': '不为', '>': '大于', '<': '小于', '>=': '不低于', '<=': '不高于' }[op] || this.operatorText(op);
    },
    matchCondition(row) {
      var field = row.field || row.field_name;
      var actual = this.getActualValue(field);
      var actualText = this.valueText(actual);
      var required = row.value;
      var requiredText = row.value_text || required;
      var actualCandidates = this.valueCandidates(actual, actualText);
      var requiredCandidates = this.valueCandidates(required, requiredText);
      switch (row.operator || "=") {
        case "=":
        case "==":
          return this.hasIntersection(actualCandidates, requiredCandidates);
        case "!=":
          return !this.hasIntersection(actualCandidates, requiredCandidates);
        case "contains":
          return actualCandidates.some((a) => requiredCandidates.some((r) => r && a.indexOf(r) !== -1));
        case "in":
          return this.hasIntersection(actualCandidates, this.valueCandidates(String(required || "").split(","), requiredText));
        case ">":
        case ">=":
        case "<":
        case "<=":
          return this.compareOrdered(actualCandidates[0], row.operator, requiredCandidates[0]);
        default:
          return true;
      }
    },
    valueText(value) {
      return Array.isArray(value) ? value.join(",") : (value == null ? "" : String(value));
    },
    getActualValue(field) {
      if (Object.prototype.hasOwnProperty.call(this.applyFieldData, field)) {
        return this.applyFieldData[field];
      }
      if (["age", "nl", "__age", "年龄"].indexOf(field) !== -1) {
        var birthdayFields = ["birthday", "birthdate", "birth_date", "csrq"];
        for (var i = 0; i < birthdayFields.length; i++) {
          var key = birthdayFields[i];
          if (this.applyFieldData[key]) return this.calculateAge(this.applyFieldData[key]);
        }
      }
      return "";
    },
    calculateAge(value) {
      var time = Date.parse(value);
      if (isNaN(time)) return "";
      var today = new Date();
      var birthday = new Date(time);
      var age = today.getFullYear() - birthday.getFullYear();
      var m = today.getMonth() - birthday.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthday.getDate())) age--;
      return String(age);
    },
    valueCandidates(value, text) {
      var list = Array.isArray(value) ? value.slice() : [value];
      if (text !== undefined && text !== null && text !== "") {
        list = list.concat(Array.isArray(text) ? text : [text]);
      }
      var normalized = list.map((item) => String(item == null ? "" : item).trim()).filter((item, index, arr) => item && arr.indexOf(item) === index);
      normalized.slice().forEach((item) => {
        if (/^[\u4e00-\u9fa5]+$/.test(item) && item.slice(-1) !== "族") normalized.push(item + "族");
        if (item.slice(-1) === "族") normalized.push(item.slice(0, -1));
      });
      return normalized.filter((item, index, arr) => item && arr.indexOf(item) === index);
    },
    hasIntersection(left, right) {
      return left.some((item) => right.indexOf(item) !== -1);
    },
    compareOrdered(actual, operator, required) {
      var left = this.toComparable(actual);
      var right = this.toComparable(required);
      if (left === null || right === null) return false;
      if (operator === ">") return left > right;
      if (operator === ">=") return left >= right;
      if (operator === "<") return left < right;
      if (operator === "<=") return left <= right;
      return false;
    },
    toComparable(value) {
      if (value === undefined || value === null || value === "") return null;
      if (!isNaN(Number(value))) return Number(value);
      var time = Date.parse(value);
      return isNaN(time) ? null : time;
    },
    registerPosition() {
      registeredPosition({
        position_code: this.pisitionId,
        project_id: this.$parent.projectDetail.project_info.id,
      }).then((res) => {
        if (res.data.code === 1) {
          this.positionModel = res.data.data;
          this.tableDetail = (res.data.data.subject_list || []).map((item) => ({
            check: item.is_must == 1, disabled: item.is_must == 1, ...item,
          }));
          this.grade_id = res.data.data.grade_id;
          this.major_id = res.data.data.major_id;
        }
      });
    },
    checkBkxx() {
      if (this.$parent.projectDetail.current_step != this.process_index) {
        this.$message.error("当前状态无法提交更改"); return false;
      }
      if (!this.selectOne) return this.$message("请选择报考地区");
      if (!this.selectTwo) return this.$message("请选择报考地市");
      if (!this.pisitionId) return this.$message("请输入职位代码");
      if (this.pisitionId && !this.grade_id) return this.$message("请确认职位代码是否正确，并且点击查询");
      if (!this.canSubmitPosition) return this.$message.error("您不符合该职位条件，无法提交");
      let checkIds = [];
      this.tableDetail.forEach((item) => { if (item.check) checkIds.push(item.id); });
      reqProjectSavedata({
        area_id: this.selectOne[0], point_id: this.selectTwo[0],
        grade_id: this.grade_id, major_id: this.major_id,
        subject_ids: checkIds, project_id: this.$parent.projectDetail.project_info.id,
        position_id: this.positionModel.id,
      }).then((res) => {
        if (res.data.code === 1) {
          reqProjectDetail({ project_id: this.$parent.projectDetail.project_info.id, step_name: "bkxx" }).then((r) => {
            if (r.data.code === 1) this.changeProject(r.data.data);
            this.$parent.next();
          }).catch(() => {
            this.$parent.next();
          });
        } else { this.$message.error(res.data.msg); }
      });
    },
    ...mapActions(useMainStore, { changeProject: "updateProjectDetail" }),
  },
  mounted() {},
};
</script>

<style scoped>
.bkxx-wrap { max-width: 900px; margin: 20px auto; }
.bkxx-card { background: #fff; border: 1px solid #e8e8e8; border-radius: 6px; margin-bottom: 16px; }
.card-header { padding: 12px 20px; border-bottom: 1px solid #e8e8e8; display: flex; align-items: center; }
.card-title { font-size: 15px; font-weight: 600; color: #303133; }
.card-tip { font-size: 13px; color: #909399; margin-left: 12px; }
.card-body { padding: 20px; }
.empty-tip { text-align: center; color: #999; padding: 40px 0; }
.bkxx-submit { text-align: center; padding: 20px 0; }
.condition-groups { margin-top: 16px; }
.condition-group { margin-bottom: 14px; padding: 12px 14px; border: 1px solid #ebeef5; border-radius: 6px; background: #fff; }
.condition-group-title { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; color: #303133; font-weight: 600; }
.condition-list { border: 1px solid #edf1f7; border-radius: 4px; overflow: hidden; }
.condition-list-item { display: flex; align-items: center; min-height: 42px; padding: 8px 10px; border-top: 1px solid #edf1f7; color: #303133; line-height: 1.6; background: #fff; }
.condition-list-item:first-child { border-top: 0; }
.condition-list-item.is-pass { background: #fbfffd; }
.condition-list-item.is-fail { background: #fffafa; }
.condition-list-index { flex: 0 0 24px; width: 24px; height: 24px; margin-right: 10px; border-radius: 50%; background: #f2f6fc; color: #606266; font-size: 12px; line-height: 24px; text-align: center; }
.condition-list-item.is-pass .condition-list-index { background: #ecf9f2; color: #19be6b; }
.condition-list-item.is-fail .condition-list-index { background: #fef0f0; color: #f56c6c; }
.condition-list-text { flex: 1; word-break: break-all; }
.condition-list-result { flex: 0 0 34px; text-align: center; }
.condition-group-tip { margin-top: 8px; color: #909399; font-size: 13px; }
.condition-pass { color: #19be6b; font-size: 18px; font-weight: 700; }
.condition-fail { color: #f56c6c; font-size: 18px; font-weight: 700; }
</style>
